import { Checkbox, Text } from "@mantine/core";
import { IconArrowNarrowDown } from "@tabler/icons-react";
import { type HTMLAttributes, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { StyledTh } from "src/styled";
import { useDispatch, useSelector } from "../../../redux/hooks";
import SelectAllCheckbox from "./SelectAllCheckbox";
import SortArrow from "../SortArrow/SortArrow";

interface ITableHeaderCell extends HTMLAttributes<HTMLTableCellElement> {
  name?: string;
  label: string;
  sortable?: boolean;
  red?: boolean;
}

const ScrollableTableHeaderCell = ({
  name,
  label,
  sortable,
  style,
  red,
  ...cellProps
}: ITableHeaderCell) => {
  const { pathname } = useLocation();

  const params = useMemo(
    () =>
      pathname.includes("search")
        ? { sort: "ssort", dir: "sdir" }
        : { sort: "sort", dir: "dir" },
    [pathname],
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const sort = searchParams.get(params.sort);
  const dir = searchParams.get(params.dir);
  const clickable = name && name !== "blank" && sortable;
  const handleClick = () => {
    if (!clickable) return;
    setSearchParams(prev => {
      prev.set(params.sort, name);
      prev.set(params.dir, dir === "asc" ? "desc" : "asc");
      return prev;
    });
  };

  const renderArrow = () => {
    if (!clickable || !sort || sort !== name) return <></>;
    return <SortArrow dir={dir as string} />;
  };
  return (
    <StyledTh
      key={name}
      red={red}
      style={{ cursor: clickable ? "pointer" : "default", ...style }}
      {...cellProps}
      onClick={handleClick}>
      <Text inherit span style={{ position: "relative" }}>
        {label}
        {renderArrow()}
      </Text>

      {name === "select-all" && <SelectAllCheckbox />}
    </StyledTh>
  );
};

export default ScrollableTableHeaderCell;
